
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/work/generated/ui/shared/outcomes/content-view/jst/MoveOutcomeDialog';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  buffer += "<div>\n  <form class='form-dialog'>\n    <div class='form-dialog-content'>\n    </div>\n    <div class='form-controls'>\n      <input type='button' class='btn' value='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("move_outcome_dialog")
  },data:data},helper ? helper.call(depth0, "cancel_caeb1e68", "Cancel", options) : helperMissing.call(depth0, "t", "cancel_caeb1e68", "Cancel", options)))
    + "'>\n      <input type='submit' class='btn btn-primary' value='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("move_outcome_dialog")
  },data:data},helper ? helper.call(depth0, "move_abf00365", "Move", options) : helperMissing.call(depth0, "t", "move_abf00365", "Move", options)))
    + "'>\n    </div>\n  <form>\n</div>";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '9f',
      bundle: 'jst/MoveOutcomeDialog'
    });
  ;
    export default templates[name];
  